import React from 'react';
import { Pagination as RaPagination } from 'react-admin';

const Pagination: React.FC = (props) => (
  <RaPagination rowsPerPageOptions={[10, 25, 50, 100, 150]} {...props} />
);

export default Pagination;
